var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { BodyText } from '../../BodyText';
import { Stack } from '../../Stack';
import { Link } from '../../Link';
import { Form } from '../../Form';
import { Icon } from '../../Icon';
import { Tag } from '../../Tag';
import { focusFirstOption, focusLastOption, FocusContext, FocusActionType, } from '../utils';
import { keys } from '../../../utilities/keyCodes';
import { Tooltip } from '../../Tooltip';
import { Button } from '../../Button';
export const AnvilSelectHeader = React.memo((props) => {
    const { className, filter, filtersApplied, onFilterClick, search, title, closeSelectHandler, clearable = true, onChange } = props, rest = __rest(props, ["className", "filter", "filtersApplied", "onFilterClick", "search", "title", "closeSelectHandler", "clearable", "onChange"]);
    const { focusState, focusDispatch } = React.useContext(FocusContext);
    const { searchFocus, filterFocus } = focusState;
    const [searchValue, setSearchValue] = React.useState('');
    const filterRef = React.useRef(null);
    const searchInputRef = React.useRef(null);
    React.useEffect(() => {
        var _a;
        filterFocus && ((_a = filterRef.current) === null || _a === void 0 ? void 0 : _a.focus());
    }, [filterFocus, filterRef]);
    const handleKeyDown = (e) => {
        var _a;
        const target = e.target;
        if (e.key === keys.esc) {
            e.preventDefault();
            closeSelectHandler();
            return;
        }
        if (target.nodeName === 'INPUT') {
            if (e.key === keys.tab && e.shiftKey) {
                e.preventDefault();
                closeSelectHandler();
                return;
            }
            if (e.key === keys.down) {
                e.preventDefault();
                focusFirstOption(e.target, closeSelectHandler);
                return;
            }
            if (e.key === keys.up) {
                e.preventDefault();
                focusLastOption(e.target, closeSelectHandler);
                return;
            }
        }
        if (e.key === keys.tab) {
            if (!e.shiftKey &&
                target.nodeName === 'INPUT' &&
                clearable &&
                !!searchValue) {
                return;
            }
            if (!e.shiftKey &&
                target.nodeName !== 'INPUT' &&
                !target.nextSibling &&
                !clearable) {
                e.preventDefault();
                focusFirstOption(e.target, closeSelectHandler);
                return;
            }
            const searchSibling = (_a = target === null || target === void 0 ? void 0 : target.closest('.Select__search')) === null || _a === void 0 ? void 0 : _a.nextSibling;
            if (!e.shiftKey &&
                target.nodeName === 'INPUT' &&
                !searchSibling) {
                e.preventDefault();
                focusFirstOption(e.target, closeSelectHandler);
                return;
            }
        }
        if (target.classList.contains('filter') &&
            (e.key === keys.enter ||
                e.key === keys.space ||
                e.key === keys.down)) {
            onFilterClick(e);
        }
    };
    const handleFocusSearchInput = () => {
        focusDispatch({
            type: FocusActionType.SetFocus,
            payload: { searchFocus: true },
        });
    };
    const clearClick = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e, { value: '' });
        setSearchValue('');
        searchInputRef.current.focus();
    };
    const onChangeHandler = (event, data) => {
        setSearchValue(data.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, data);
    };
    const clearBtnClassNames = classnames('Select__search-clear', {
        'Select__search-clear--loading': props.loading,
    });
    const getClearable = () => {
        if (!clearable || !searchValue)
            return;
        return (React.createElement(Tooltip, { text: "Clear search", className: clearBtnClassNames, direction: "bl" },
            React.createElement(Button, { xsmall: true, fill: "subtle", iconName: "clear", onClick: clearClick })));
    };
    const AnvilSelectHeaderClassNames = classnames('Select__header', className);
    return (React.createElement("div", { className: AnvilSelectHeaderClassNames, onKeyDown: handleKeyDown },
        title && (React.createElement(BodyText, { className: "Select__title ff-display lh-1", bold: true, size: "small" }, title)),
        React.createElement(Stack, { className: "Select__header-controls w-100" },
            search && (React.createElement(Stack.Item, { fill: true, className: "Select__search" },
                React.createElement(Form, null,
                    React.createElement(Form.Input, Object.assign({ autoFocus: searchFocus, onFocus: handleFocusSearchInput, icon: "search", iconPosition: "left", size: "small", onChange: onChangeHandler, value: searchValue, inputRef: searchInputRef }, rest))),
                getClearable())),
            filter && (React.createElement(Link, { size: 2, className: "Select__filter d-f fs-2 fw-bold align-items-center", onClick: onFilterClick },
                React.createElement("span", { className: "Select__focus filter", ref: filterRef },
                    React.createElement(Stack, { alignItems: "center" },
                        React.createElement(Icon, { name: "funnel" }),
                        "Filter",
                        filtersApplied > 0 && (React.createElement(Tag, { badge: true, compact: true, className: "m-l-half" }, filtersApplied)))))))));
});
//# sourceMappingURL=SelectHeader.js.map